var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceMobileCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.9375V4.0625C19.5 3.16504 18.7725 2.4375 17.875 2.4375L8.125 2.4375C7.22754 2.4375 6.5 3.16504 6.5 4.0625L6.5 21.9375C6.5 22.835 7.22754 23.5625 8.125 23.5625H17.875C18.7725 23.5625 19.5 22.835 19.5 21.9375Z",
    stroke: "#283E24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.10938C13.5609 7.10938 14.0156 6.65466 14.0156 6.09375C14.0156 5.53284 13.5609 5.07812 13 5.07812C12.4391 5.07812 11.9844 5.53284 11.9844 6.09375C11.9844 6.65466 12.4391 7.10938 13 7.10938Z",
    fill: "#283E24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMobileCamera);
export default __webpack_public_path__ + "static/media/DeviceMobileCamera.fc0e397566195ade0a554e59c45f846e.svg";
export { ForwardRef as ReactComponent };